
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 90 90"}},[_c('path',{attrs:{"d":"M10 31.5H0V0h31.5v10H10zM90 90H58.5V80H80V58.5h10zM31.5 90H0V58.5h10V80h21.5zM90 31.5H80V10H58.5V0H90z"}})])
      }
    
      }
    